var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.root},[_c('MerchantLogo',{class:_vm.$style.merchant})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }